import React, { useEffect, useState } from 'react';

import CustomCheckBox from '../../../components/customCheckBox';
import CustomCalendar from '../../../components/customCalendar';

import { useSelector } from 'react-redux';
import { getSelectedCompany } from '../../../redux/company/actions';

import API from '../../../services/api';
import utils from '../../../utils';

import './styles.scss';

const CreateCampaignBody = ({ campaignInfo, onChangeCB }) => {
  const [campaignName, setCampaignName] = useState(campaignInfo?.campaignName || '');
  const [startDate, setStartDate] = useState(campaignInfo?.startDate || '');
  const [endDate, setEndDate] = useState(campaignInfo?.endDate || '');
  const [selectedSites] = useState(campaignInfo?.selectedSites || []);
  const [sitesOptions, setSitesOptions] = useState([]);
  const [currentFilter, setCurrentFilter] = useState('');
  const [isOngoingCampaign, setIsOngoingCampaign] = useState(campaignInfo?.isOngoingCampaign || false);

  const company = useSelector(getSelectedCompany);

  useEffect(() => {
    onLoadSites();
  }, []);

  useEffect(() => {
    onChangeCB({
      ...campaignInfo,
      campaignName,
      startDate,
      endDate: isOngoingCampaign ? null : endDate,
      selectedSites,
      isOngoingCampaign
    });
  }, [campaignName, startDate, endDate, selectedSites, isOngoingCampaign]);

  const onLoadSites = (nextPageToken, searchingBy = '') => {
    const query = encodeURI(`displayName ILIKE "%${searchingBy}%" OR id ILIKE "%${searchingBy}%"`);
    const filter = searchingBy !== '' ? query : '';

    if (filter !== currentFilter) {
      setSitesOptions([]);
    }

    return API.getSitesByCompany(company.id, nextPageToken, filter, 'displayName, id', 40).then(response => {
      const fetchedSites = response.sites.map(site => ({
        value: site.id,
        label: site.displayName
      }));

      // Reset list when filter changes
      if (filter !== currentFilter) {
        setCurrentFilter(filter);
        setSitesOptions(fetchedSites);
      } else {
        const newSites = utils.mergeArraysByField(fetchedSites, sitesOptions, 'value');
        setSitesOptions(newSites);
      }

      return response.nextPageToken;
    });
  };

  return (
    <>
      <div className="row">
        <div className="col-8">
          <div className="form-group">
            <label>Campaign Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter campaign name"
              value={campaignName}
              onChange={e => setCampaignName(e.target.value)}
            />
          </div>
        </div>
        <div className="col-4">
          <div className="form-group">
            <label>&nbsp;</label>
            <CustomCheckBox
              selected={'none'}
              onClick={() => setIsOngoingCampaign(!isOngoingCampaign)}
              label="Ongoing Campaign"
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-6">
          <div className="form-group">
            <label>Start Date</label>
            <CustomCalendar
              classes="simple-calendar"
              value={startDate}
              onChange={setStartDate}
              showNeighboringMonth={false}
              activeStartDate={new Date().now}
            />
          </div>
        </div>
        <div className="col-6">
          <div className="form-group">
            <label className={`end-date-label${isOngoingCampaign ? ' disabled' : ''}`}>End Date</label>
            <CustomCalendar
              disabled={isOngoingCampaign}
              value={endDate}
              onChange={setEndDate}
              showNeighboringMonth={false}
              activeStartDate={new Date().now}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateCampaignBody;
